import { FC } from 'react';

interface SkeletonContentGroupProps {
	className?: string;
}

export const SkeletonContentGroup: FC<SkeletonContentGroupProps> = ({
	className = 'skeleton-content-group'
}) => {
	return (
		<div className={className}>
			<div className="skeleton-content-line-long" />
			<div className="skeleton-content-line-full" />
			<div className="skeleton-content-line-medium" />
		</div>
	);
};
